import React, { useEffect, useState } from 'react'
import TableActionsWrapper from 'components/Wrapper/TableActionsWrapper';
import TableSearchWrapper from 'components/Wrapper/TableSearchWrapper';
import TableWrapper from 'components/Wrapper/TableWrapper';
import { appRoutes } from 'constants/appRoutes';
import { Badge, Button, Card, Col, Form, FormCheck, Row, Table } from 'react-bootstrap'
import { InfoCircle, List, PencilSquare, Plus, Trash } from 'react-bootstrap-icons';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { apiUrls } from 'constants/apiUrls';
import { invoiceService } from 'services/invoiceService';
import ProgressLoader from 'components/Loader/ProgressLoader';
import { appRoutesUrls } from 'constants/appRoutesUrls';
import { ddMMyyyy, toDDMMYYYY, toDDMMYYYYHHMMSS } from 'utils/dateFormatter';
import { deleteOnConfirm } from 'components/Confirm/ConfirmDialog';
import { allowNumber } from 'utils/inputValidator';
import { bgInvoiceStatus, bgPaymentStatus } from 'utils/bgColor';
import DatePicker from 'react-datepicker';
import { ButtonExportCsv, ButtonExportExcel, ButtonReset, ButtonSearch } from 'components/Buttons/Buttons';
import { invoiceStatus } from 'constants/invoice/invoiceStatus';
import { roundTo } from 'utils/numberFormatter';
import TablePagingWrapper from 'components/Wrapper/TablePagingWrapper';
import TablePagination, { pageOptions } from 'components/Paginate/TablePagination';
import { BiFilterAlt } from 'react-icons/bi';

const InvoiceList = ({ customerId, customerName }) => {
    const navigate = useNavigate();
    const [isLoader, setIsLoader] = useState(false);
    const [showMore, setShowMore] = useState(false);
    const [invoices, setInvoices] = useState();
    const [showFilter, setShowFilter] = useState(true);
    const initialFilters = {
        currentPage: pageOptions.currentPage,
        pageSize: pageOptions.pageSize,
        orderBy: 'invoiceDate desc',
        customerId: customerId,
        invoiceId: '',
        invoiceNo: '',
        dateFrom: '',
        dateTo: '',
        customerName: '',
        invoiceStatusId: '',
        paymentStatusId: '',
        isActive: true
    };
    const [filters, setFilters] = useState(initialFilters);

    useEffect(() => {
        getInvoices(filters);
    }, [])

    const getInvoices = (filters) => {
        setIsLoader(true);
        invoiceService.getInvoices(apiUrls.getInvoices(), filters).then(res => {
            setIsLoader(false);
            setInvoices(res);
        }).catch((err) => setIsLoader(false));
    }

    const deleteInvoice = (id) => {
        setIsLoader(true);
        invoiceService.deleteInvoice(apiUrls.deleteInvoice(id)).then(res => {
            setIsLoader(false);
            toast.success("Invoice deleted successfully");
            getInvoices(filters);
        }).catch((err) => setIsLoader(false));
    }

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;

        if (name === "invoiceId" && !allowNumber(e.target.value)) { return; }

        setFilters((preValue) => ({
            ...preValue, [name]: (type === 'checkbox' ? checked : value)
        }));
    }

    const setDateFrom = (value) => {
        setFilters((preValue) => ({
            ...preValue, "dateFrom": value
        }));
    }

    const setDateTo = (value) => {
        setFilters((preValue) => ({
            ...preValue, "dateTo": value
        }));
    }

    const handleSearch = () => {
        let searchFilters = { ...filters, currentPage: 1 }
        setFilters(searchFilters);
        getInvoices(searchFilters);
    }

    const handleReset = () => {
        setFilters(initialFilters);
        getInvoices(initialFilters);
    }

    const handlePageClick = (e) => {
        let pageFilters = { ...filters, currentPage: (e.selected + 1) }
        setFilters(pageFilters);
        getInvoices(pageFilters);
    }

    const handlePageSizeChange = (e) => {
        let pageFilters = { ...filters, pageSize: e.target.value, currentPage: pageOptions.currentPage }
        setFilters(pageFilters);
        getInvoices(pageFilters);
    }

    const handleExport = (option) => {
        console.log(option);
    }

    return (
        <>
            {isLoader && <ProgressLoader />}
            <Card className='card-default'>
                <Card.Body>
                    <Card.Title>
                        <List size={24} /> Invoices {invoices && `(${invoices?.totalItems})`} {customerName && <strong>- {customerName}</strong>}
                        <BiFilterAlt size={24} className='float-end hand'
                            color={(showFilter ? '#0d6efd' : '#6c757d')}
                            onClick={() => setShowFilter(!showFilter)} />
                    </Card.Title>
                    {showFilter && (
                        <TableSearchWrapper>
                            <Form noValidate>
                                <Row>
                                    {!customerId > 0 && (
                                        <Col md={3}>
                                            <Form.Control
                                                type="text"
                                                placeholder="Customer Name"
                                                name='customerName'
                                                value={filters.customerName}
                                                onChange={handleChange}
                                                maxLength={20}
                                                className="mb-3" />
                                        </Col>
                                    )}
                                    <Col md={3}>
                                        <DatePicker
                                            placeholderText="From Invoice Date"
                                            selected={filters.dateFrom}
                                            onSelect={setDateFrom}
                                            dateFormat={ddMMyyyy}
                                            className="form-control mb-3" />
                                    </Col>
                                    <Col md={3}>
                                        <DatePicker
                                            placeholderText="To Invoice Date"
                                            selected={filters.dateTo}
                                            onSelect={setDateTo}
                                            dateFormat={ddMMyyyy}
                                            className="form-control mb-3" />
                                    </Col>
                                    <Col md={3}>
                                        <Form.Control
                                            type="text"
                                            placeholder="INV ID"
                                            name={'invoiceId'}
                                            value={filters.invoiceId}
                                            onChange={handleChange}
                                            maxLength={10}
                                            className="mb-3" />
                                    </Col>
                                    <Col md={3}>
                                        <Form.Control
                                            type="text"
                                            placeholder="Invoice No"
                                            name='invoiceNo'
                                            value={filters.invoiceNo}
                                            onChange={handleChange}
                                            maxLength={10}
                                            className="mb-3" />
                                    </Col>
                                    <Col md={3}>
                                        <Form.Select
                                            name='invoiceStatusId'
                                            value={filters.invoiceStatusId}
                                            onChange={handleChange}
                                            className="mb-2">
                                            <option value="">All Invoice Status</option>
                                            <option value="1">InProgress</option>
                                            <option value="2">Completed</option>
                                        </Form.Select>
                                    </Col>
                                    <Col md={3}>
                                        <Form.Select
                                            name='paymentStatusId'
                                            value={filters.paymentStatusId}
                                            onChange={handleChange}
                                            className="mb-2">
                                            <option value="">All Payment Status</option>
                                            <option value="1">Unpaid</option>
                                            <option value="2">Paid</option>
                                            <option value="3">Partly Paid</option>
                                        </Form.Select>
                                    </Col>
                                    <Col md={customerId > 0 ? 3 : 1} sm={6}>
                                        <Form.Check
                                            type="checkbox"
                                            name='isActive'
                                            checked={filters.isActive}
                                            onChange={handleChange}
                                            label="Active"
                                        />
                                    </Col>
                                    <Col md={customerId > 0 ? 3 : 2} sm={6} className="text-right">
                                        <ButtonSearch onClick={handleSearch} />
                                        <ButtonReset onClick={handleReset} />
                                    </Col>
                                </Row>
                            </Form>
                        </TableSearchWrapper>
                    )}
                    <TableActionsWrapper>
                        <Row className='mt-1'>
                            <Col sm={8}>
                                <Button
                                    size="sm"
                                    type="button"
                                    variant="primary"
                                    className='mw-100'
                                    onClick={() => customerId > 0 ?
                                        navigate(appRoutesUrls.customerInvoiceAdd(customerId)) :
                                        navigate(appRoutes.customers)
                                    }>
                                    <Plus size={24} /> Invoice
                                </Button>
                                {customerId > 0 && (
                                    <Button
                                        size="sm"
                                        type="button"
                                        variant="secondary"
                                        className='mw-100 ms-1'
                                        onClick={() => customerId > 0 ?
                                            navigate(appRoutesUrls.customerInvoiceItems(customerId)) :
                                            navigate(appRoutes.customers)
                                        }>
                                        <Plus size={24} /> Invoice Items
                                    </Button>
                                )}
                            </Col>
                            <Col sm={4} className='text-right'>
                                <ButtonExportExcel onClick={() => handleExport('excel')} />
                                <ButtonExportCsv onClick={() => handleExport('csv')} />
                                <FormCheck
                                    type="switch"
                                    className='ms-2 pull-right'
                                    label=""
                                    onChange={() => setShowMore(!showMore)}
                                    title={`Show ${showMore ? 'Less' : 'More'} Columns`}
                                />
                            </Col>
                        </Row>
                    </TableActionsWrapper>
                    <TableWrapper>
                        <Table striped hover responsive>
                            <thead>
                                <tr>
                                    <th className='col-action-80'>Action</th>
                                    <th style={{ minWidth: '60px' }}>INV ID</th>
                                    <th style={{ width: '100px' }}>Invoice Date</th>
                                    <th style={{ width: '50px' }}>Invoice No</th>
                                    {!customerId > 0 && (<th style={{ width: '250px' }}>Customer Name</th>)}
                                    <th>Items<br />Count</th>
                                    <th className='text-right'>Items<br />Total</th>
                                    <th className='text-right'>- Items<br />Discount</th>
                                    <th className='text-right'>Items<br />Amount</th>
                                    <th className='text-right'>+GST<br />Amount</th>
                                    <th className='text-right'>+Prev<br />Balance</th>
                                    <th className='text-right'>Invoice<br />Amount</th>
                                    <th>Invoice<br />Status</th>
                                    <th>Payment<br />Status</th>
                                    <th className='text-right'>Paid<br />Amount</th>
                                    <th style={{ width: '100px' }}>Paid Date</th>
                                    <th className='text-right'>Balance<br />Amount</th>
                                    {showMore && (
                                        <>
                                            <th>Added Date</th>
                                            <th>Added By</th>
                                            <th>Modified Date</th>
                                            <th>Modified By</th>
                                        </>
                                    )}
                                </tr>
                            </thead>
                            <tbody>
                                {invoices?.items && invoices?.items.map((invoice, i) => (
                                    <tr key={i}>
                                        <td>
                                            <Button
                                                as={Link}
                                                size='sm'
                                                variant={invoice.paymentStatus === invoiceStatus.paid ? "primary" : "secondary"}
                                                className='btn-action ms-1'
                                                to={appRoutesUrls.invoicedetails(invoice.id)}>
                                                {invoice.paymentStatus === invoiceStatus.paid ? <InfoCircle /> : <PencilSquare />}
                                            </Button>
                                            {invoice.isActive && (
                                                <Button
                                                    size='sm'
                                                    variant="danger"
                                                    className='btn-action ms-1'
                                                    onClick={() => deleteOnConfirm(invoice.id, deleteInvoice, null)}>
                                                    <Trash />
                                                </Button>
                                            )}
                                        </td>
                                        <td><b>{invoice.id}</b></td>
                                        <td>{toDDMMYYYY(invoice.invoiceDate)}</td>
                                        <td>{invoice.invoiceNo}</td>
                                        {!customerId > 0 && (
                                            <td onClick={() => navigate(appRoutesUrls.customerInvoices(invoice.customerId))} className="hand">
                                                {invoice.customerName}
                                            </td>
                                        )}
                                        <td>{invoice.items}</td>
                                        <td align='right'><b>{roundTo(invoice.itemsAmount)}</b></td>
                                        <td align='right'>{roundTo(invoice.disAmount)}</td>
                                        <td align='right'><b>{roundTo(invoice.totalAmount)}</b></td>
                                        <td align='right'><small>({invoice.gstPerc}%)</small> {roundTo(invoice.gstAmount)}</td>
                                        <td align='right'>{roundTo(invoice.prevBalance)}</td>
                                        <td align='right'><b>{roundTo(invoice.invoiceAmount)}</b></td>
                                        <td>
                                            <Badge bg={bgInvoiceStatus(invoice.invoiceStatus)}>
                                                {invoice.invoiceStatus}
                                            </Badge>
                                        </td>
                                        <td>
                                            <Badge bg={bgPaymentStatus(invoice.paymentStatus)}>
                                                {invoice.paymentStatus}
                                            </Badge>
                                        </td>
                                        <td align='right'><b>{roundTo(invoice.paidAmount)}</b></td>
                                        <td>{toDDMMYYYY(invoice.paidDate)}</td>
                                        <td align='right'>
                                            <b className={invoice.balanceAmount > 0 ? 'text-danger' : 'text-success'}>
                                                {roundTo(invoice.balanceAmount)}
                                            </b>
                                        </td>
                                        {showMore && (
                                            <>
                                                <td>{toDDMMYYYYHHMMSS(invoice.addedDate)}</td>
                                                <td>{invoice.addedBy}</td>
                                                <td>{toDDMMYYYYHHMMSS(invoice.modifiedDate)}</td>
                                                <td>{invoice.modifiedBy}</td>
                                            </>
                                        )}
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </TableWrapper>
                    <TablePagingWrapper>
                        <TablePagination
                            pageSize={filters.pageSize}
                            currentPage={filters.currentPage}
                            totalPages={invoices?.totalPages}
                            totalItems={invoices?.totalItems}
                            onPageChange={handlePageClick}
                            onPageSizeChange={handlePageSizeChange}
                            pageTitle="Invoices"
                        />
                    </TablePagingWrapper>
                </Card.Body>
            </Card>
        </>
    )
}

export default InvoiceList;